/* eslint-disable no-param-reassign */
/* eslint-disable no-console */
import { HubConnectionBuilder, LogLevel } from '@microsoft/signalr'

export default {
  install(Vue) {
    // use a new Vue instance as the interface for Vue components to receive/send SignalR events
    // this way every component can listen to events or send new events using this.$punchHub
    const notificationHub = new Vue()
    Vue.prototype.$notificationHub = notificationHub

    // Provide methods to connect/disconnect from the SignalR hub
    let connection = null
    let startedPromise = null
    let manuallyClosed = false

    notificationHub.isStarted = () => !!startedPromise
    notificationHub.start = accessToken => {
      if (connection) {
        return Promise.reject(new Error('[NotificationHub] SignalR is already started or starting'))
      }

      connection = new HubConnectionBuilder()
        .withUrl(`${process.env.VUE_APP_API_ENDPOINT}/api/hubs/notifications`, {
          accessTokenFactory: () => accessToken,
        })
        .configureLogging(LogLevel.Information)
        .build()

      // Forward hub events through the event, so we can listen for them in the Vue components
      connection.on('basic-notification', notification => {
        notificationHub.$emit('basic-notification', notification)
      })
      connection.on('import-notification', notification => {
        notificationHub.$emit('import-notification', notification)
      })
      connection.on('refresh-notification', () => {
        notificationHub.$emit('refresh-notification')
      })

      // You need to call connection.start() to establish the
      // connection but the client wont handle reconnecting for you!
      // Docs recommend listening onclose and handling it there.
      // This is the simplest of the strategies
      function start() {
        startedPromise = connection.start().catch(err => {
          console.error('[NotificationHub] Failed to connect with hub', err)
          return new Promise(
            (resolve, reject) => setTimeout(() => start().then(resolve).catch(reject), 5000),
            // eslint-disable-next-line function-paren-newline
          )
        })
        return startedPromise
      }
      connection.onclose(() => {
        if (!manuallyClosed) start()
      })

      // Start everything
      manuallyClosed = false
      return start()
    }
    notificationHub.stop = () => {
      if (!startedPromise) {
        return Promise.reject(new Error('[NotificationHub] SignalR not started'))
      }

      manuallyClosed = true
      return startedPromise
        .then(() => connection.stop())
        .then(() => {
          startedPromise = null
        })
        .catch(console.error)
    }
  },
}
